import './AllSubjects.css';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStudentSubjects, getTeacherSubjects } from "../../redux/slices/subjectsSlice";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router";


function AllSubjects() {
    const dispatch = useDispatch();
    const { isDarkMode } = useDarkMode();
    const navigate = useNavigate();
    const { studentSubjects, teacherSubjects, subjectsLoading, subjectsError } = useSelector((state) => state.subjects);
    const { currentUser } = useSelector((state) => state.auth);


    // تحديد دور المستخدم
    const userRole = currentUser?.role || localStorage.getItem("userRole");
    const isTeacher = userRole === "teacher";

    useEffect(() => {
        window.scrollTo(0, 0);
        
        // جلب المواد حسب دور المستخدم
        if (isTeacher) {
            dispatch(getTeacherSubjects());
        } else {
            dispatch(getStudentSubjects());
        }
    }, [dispatch, isTeacher]);

    // Mapping للأيقونات حسب اسم المادة
    const getSubjectIcon = (subjectTitle) => {
        const iconMap = {
            "الرياضيات": "/math.png",
            "الدراسات الاجتماعية": "/drasat.png",
            "اللغة العربية": "/arabic.png",
            "العلوم": "/science.png",
            "الجغرافيا": "/gohraphia.png",
            "الفيزياء": "/physic.png",
            "التاريخ": "/tarekh.png",
            "اللغة الإنجليزية": "/english.png", // للتوافق مع البيانات القادمة من API
        };
        return iconMap[subjectTitle] || "/science.png"; // أيقونة افتراضية إذا لم توجد
    };

    // تحديد المواد التي سيتم عرضها
    const subjectsToShow = isTeacher ? (teacherSubjects || []) : (studentSubjects || []);

    // لإضافة Animation عند تحميل الصفحة
    useEffect(() => {
        const cards = document.querySelectorAll(".subject-card");
        cards.forEach((card, i) => {
            setTimeout(() => {
                card.classList.add("show");
            }, i * 150);
        });
    }, [subjectsToShow]); // إعادة تشغيل عند تغيير البيانات

    // عرض loading إذا كانت البيانات قيد التحميل
    if (subjectsLoading) {
        return (
            <div className={`all-lessons-page subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                <div className="container">
                    {/* Breadcrumb */}
                    <div className="lessons-breadcrumb">
                        <h1 className="breadcrumb-title">المواد الدراسية</h1>
                        <div className="breadcrumb-links2">
                            <span className="breadcrumb-link">الرئيسية</span>
                            <span className="breadcrumb-separator">/</span>
                            <span className="breadcrumb-current">المواد الدراسية</span>
                        </div>
                    </div>

                    <div className="text-center">
                        <h3 className="subjects-subtitle">فئات علمي</h3>
                        <h2 className="subjects-title">اتعلم جميع المواد</h2>
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="loading-spinner">جاري تحميل المواد الدراسية...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // عرض error إذا كان هناك خطأ
    if (subjectsError) {
        return (
            <div className={`all-lessons-page subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                <div className="container">
                    {/* Breadcrumb */}
                    <div className="lessons-breadcrumb">
                        <h1 className="breadcrumb-title">المواد الدراسية</h1>
                        <div className="breadcrumb-links2">
                            <span className="breadcrumb-link">الرئيسية</span>
                            <span className="breadcrumb-separator">/</span>
                            <span className="breadcrumb-current">المواد الدراسية</span>
                        </div>
                    </div>

                    <div className="text-center">
                        <h3 className="subjects-subtitle">فئات علمي</h3>
                        <h2 className="subjects-title">اتعلم جميع المواد</h2>
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="error-message">حدث خطأ في تحميل المواد الدراسية</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`all-lessons-page subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="container">
                {/* Breadcrumb */}
                <div className="lessons-breadcrumb">
                    <h1 className="breadcrumb-title">المواد الدراسية</h1>
                    <div className="breadcrumb-links2">
                        <span className="breadcrumb-link">الرئيسية</span>
                        <span className="breadcrumb-separator">/</span>
                        <span className="breadcrumb-current">المواد الدراسية</span>
                    </div>
                </div>

                <div className="text-center">
                 

                <div className="row justify-content-center">
                        {Array.isArray(subjectsToShow) && subjectsToShow.length > 0 ? (
                            subjectsToShow.map((subject, index) => (
                                <div className="col-md-6 col-lg-3 col-12 mb-4" key={subject.id}>
                                    <Link to={isTeacher ? `/lessons` : `/subject-teachers/${subject.id}`} className='text-decoration-none'>
                                        <div className="subject-card mx-auto text-center">
                                            <img 
                                                style={{ width: "50px", height: "50px" }} 
                                                src={getSubjectIcon(subject.title)} 
                                                alt={subject.title} 
                                                className="subject-icon" 
                                            />
                                            <h3 className="subject-name">{subject.title}</h3>
                                        </div>     
                                    </Link>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center">
                                <div className="no-subjects-message">
                                    <div className="no-subjects-icon">📚</div>
                                    <h4>لا توجد مواد دراسية</h4>
                                    <p>لا توجد مواد دراسية متاحة حالياً</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllSubjects; 